import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { NumberInput, SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import type { IPredictionQuestion } from "@framework/types";
import { ContractStatus, ModuleType, PredictionQuestionStatus, TokenType } from "@framework/types";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { cleanUpAsset } from "@framework/exchange";

import { validationSchema } from "./validation";

export interface IRaffleDialogFormProps extends IMutationProps, Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IPredictionQuestion | null;
}

export const PredictionQuestionDialogForm = (props: IRaffleDialogFormProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const { id, title, contractId, description, questionStatus, price, maxVotes } = selectedItem;

  const fixedValues = {
    id,
    contractId,
    title,
    description,
    questionStatus,
    price,
    maxVotes,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="PredictionQuestionEditForm"
      filter={({ title, description, questionStatus, price, contractId, maxVotes }) =>
        mode === "edit"
          ? {
              title,
              description,
              questionStatus,
              price: cleanUpAsset(price) as any,
            }
          : {
              contractId,
              title,
              description,
              maxVotes,
              price: cleanUpAsset(price) as any,
            }
      }
      {...rest}
    >
      <EntityInput
        name="contractId"
        controller="contracts"
        fetchData={{
          contractModule: [ModuleType.PREDICTION],
          contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
        }}
        readOnly={!!id}
      />
      <TextInput name="title" />
      <RichTextEditor name="description" />
      {/* Todo - maxVotes editable untill the question is not started */}
      <NumberInput name="maxVotes" readOnly={!!id} />
      <TemplateAssetInput
        autoSelect
        prefix="price"
        tokenType={{ disabledOptions: [TokenType.ERC721, TokenType.ERC998] }}
      />
      {mode === "edit" && <SelectInput name="questionStatus" options={PredictionQuestionStatus} />}
    </FormDialog>
  );
};
